// Component_Header_Notification.tsx
import React from 'react';
import './Component_Header_Notification.css';
import '../Icons/Icons_Repository';
import Icons_Repository from '../Icons/Icons_Repository';
import { Pairing, InterviewPairingsResponse } from '../Requests/interviewPairings';
interface HeaderNotificationProps {
  pairingsData: InterviewPairingsResponse | null;
  message?: string;
  actionText?: string;
  onActionClick?: () => void;
}

function Component_Header_Notification({ 
  pairingsData,
  message = "Confirm your interview slots!", 
  actionText = `Click on "ask me" to book interviews, reschedule, and more.`,
  onActionClick 
}: HeaderNotificationProps) {
  return (
    <div className='header-notification-container'>
        <div className='header-notification-left'>
          {pairingsData?.job_title && (
            <div className='header-notification-job-title-wrapper'>
              <div className='header-notification-job-title'>
                {pairingsData.job_title}
              </div>
            </div>
          )}
          <div className='header-notification-content-wrapper'>
            <div className='header-notification'>
              <div className='notification-icon'> 
                <Icons_Repository iconName='bell'/>
              </div>
            </div>
            <div className='header-notification-message'>
              <p className='header-notification-text'>{message}</p>
            </div>
          </div>
          {/* <div className='header-notification-content-wrapper'>
            <div className='header-notification'>
              <div className='notification-icon'> 
                <Icons_Repository iconName='bell'/>
              </div>
            </div>
            <div className='header-notification-message'>
              <p className='header-notification-text'>{message}</p>
            </div>
          </div> */}
        </div>
        {/* <div className='header-notification-right'>
          <div className='header-notification-action-text'>{actionText}</div>
        </div> */}
    </div>
  );
}

export default Component_Header_Notification;